import React, { useState } from "react";

const VagaContext = React.createContext([{}, () => {}]);

const VagaProvider = props => {
  const [state, setState] = useState({
    data: null,
    loading: false
  });
  return (
    <VagaContext.Provider value={[state, setState]}>
      {props.children}
    </VagaContext.Provider>
  )
}

export { VagaContext, VagaProvider };
